import Dialog from './Dialog.vue'
import { createApp, reactive, ref, h } from 'vue'

// 全局Dialog状态
const dialogState = reactive({
  visible: false,
  title: '提示',
  message: '',
  type: 'info',
  showCancel: false,
  confirmText: '确定',
  cancelText: '取消',
  width: null,
  customClass: ''
})

// 事件回调
let currentCallbacks = {
  onConfirm: null,
  onCancel: null,
  onClose: null
}

// 创建全局Dialog实例
let dialogInstance = null
let dialogApp = null

const createDialog = () => {
  if (dialogInstance) return dialogInstance
  
  const container = document.createElement('div')
  container.id = 'global-dialog-container'
  document.body.appendChild(container)
  
  
  // 创建Dialog包装组件
  const DialogWrapper = {
    components: { Dialog },
    setup() {
      return { 
        dialogState,
        handleConfirm: () => {
          if (currentCallbacks.onConfirm) {
            currentCallbacks.onConfirm()
          }
          dialogState.visible = false
        },
        handleCancel: () => {
          if (currentCallbacks.onCancel) {
            currentCallbacks.onCancel()
          }
          dialogState.visible = false
        },
        handleClose: () => {
          if (currentCallbacks.onClose) {
            currentCallbacks.onClose()
          }
          dialogState.visible = false
        }
      }
    },
    render() {
      return h(Dialog, {
        ...dialogState,
        'onUpdate:visible': (value) => {
          dialogState.visible = value
        },
        onConfirm: () => {
          if (currentCallbacks.onConfirm) {
            currentCallbacks.onConfirm()
          }
          dialogState.visible = false
        },
        onCancel: () => {
          if (currentCallbacks.onCancel) {
            currentCallbacks.onCancel()
          }
          dialogState.visible = false
        },
        onClose: () => {
          if (currentCallbacks.onClose) {
            currentCallbacks.onClose()
          }
          dialogState.visible = false
        }
      })
    }
  }
  
  dialogApp = createApp(DialogWrapper)
  dialogInstance = dialogApp.mount(container)
  
  return dialogInstance
}

const showDialog = (options = {}) => {
  const {
    title = '提示',
    message = '',
    type = 'info',
    showCancel = false,
    confirmText = '确定',
    cancelText = '取消',
    width = null,
    customClass = '',
    onConfirm = null,
    onCancel = null,
    onClose = null
  } = options
  
  // 更新Dialog状态
  Object.assign(dialogState, {
    visible: true,
    title,
    message,
    type,
    showCancel,
    confirmText,
    cancelText,
    width,
    customClass
  })
  
  // 更新回调函数
  currentCallbacks = {
    onConfirm,
    onCancel,
    onClose
  }
  
  // 确保Dialog实例存在
  if (!dialogInstance) {
    createDialog()
  }
  
  return dialogInstance
}

const hideDialog = () => {
  dialogState.visible = false
}

const JDialog = {
  install: function(app) {
    app.component('JDialog', Dialog)
    
    // 添加全局方法
    app.config.globalProperties.$dialog = {
      show: showDialog,
      hide: hideDialog,
      info: (message, options = {}) => showDialog({ ...options, message, type: 'info' }),
      success: (message, options = {}) => showDialog({ ...options, message, type: 'success' }),
      warning: (message, options = {}) => showDialog({ ...options, message, type: 'warning' }),
      error: (message, options = {}) => showDialog({ ...options, message, type: 'error' })
    }
  }
}

export default JDialog
export { showDialog, hideDialog, dialogState }
